import Countdown from './Countdown';
import GlitchTitle from './GlitchTitle';
import IsoCube from './IsoCube';
import { POST_GENERATION_TO_VOTING_SEC } from '../lib/postGenerationToVoting';
import styles from './GeneratingPanel.module.css';

export interface GeneratingPanelProps {
  color: string;
  name: string | null | undefined;
  slot: number;
  generationFinishedAt?: string | null;
  variant: 'fullscreen' | 'slot';
  /** Maxischermo a 2 slot: UI generazione più grande nella cella. */
  slotEnlarged?: boolean;
  /** Id unico per gradienti SVG del cubo (obbligatorio se più istanze in pagina). */
  cubeUid?: string;
}

export default function GeneratingPanel({
  color,
  name,
  slot,
  generationFinishedAt,
  variant,
  slotEnlarged = false,
  cubeUid,
}: GeneratingPanelProps) {
  const showCountdown = !!generationFinishedAt;
  const isSlot = variant === 'slot';
  const wrapClass = isSlot
    ? slotEnlarged
      ? `${styles.wrapSlot} ${styles.wrapSlotEnlarged}`
      : styles.wrapSlot
    : styles.wrapFullscreen;
  const cubeWrapClass = isSlot
    ? slotEnlarged
      ? `${styles.cubeWrapSlot} ${styles.cubeWrapSlotEnlarged}`
      : styles.cubeWrapSlot
    : styles.cubeWrapFullscreen;
  const titleClass = isSlot
    ? slotEnlarged
      ? `${styles.titleSlot} ${styles.titleSlotEnlarged}`
      : styles.titleSlot
    : styles.titleFullscreen;
  const uid = cubeUid ?? (isSlot ? `screen-gen-${slot}` : 'gen-cube');

  return (
    <div className={wrapClass}>
      <span className={styles.identity} style={{ color }}>
        <span className={styles.identityDot} style={{ background: color }} aria-hidden />
        {(name ?? 'PARTECIPANTE').toUpperCase()}
      </span>

      <div className={cubeWrapClass}>
        <IsoCube uid={uid} className={styles.cube} />
      </div>

      <GlitchTitle
        text="GENERAZIONE…"
        as="h2"
        className={titleClass}
        style={isSlot ? { color: '#fff' } : undefined}
      />

      <div className={styles.progress} aria-hidden="true">
        {[0, 1, 2, 3, 4].map((i) => (
          <span
            key={i}
            className={styles.progressBar}
            style={{
              background: color,
              animationDelay: `${i * 220}ms`,
            }}
          />
        ))}
      </div>

      <div className={styles.countdown}>
        {showCountdown ? (
          <>
            <span className={styles.countdownLabel}>VOTO APERTO TRA</span>
            <span className={styles.countdownValue}>
              <Countdown
                startIso={generationFinishedAt!}
                durationSec={POST_GENERATION_TO_VOTING_SEC}
              />
            </span>
          </>
        ) : (
          <span className={styles.countdownLabel}>ATTENDI IL TUO OUTPUT</span>
        )}
      </div>
    </div>
  );
}
